'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _iBem = require('../../i-bem/i-bem.react');

var _bButton2MThemeWebsearch = (require('./../../button2/button2.react.js').default || require('./../../button2/button2.react.js')).applyDecls();

var _bButton2MThemeWebsearch2 = _interopRequireDefault(_bButton2MThemeWebsearch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

exports.default = (0, _iBem.decl)({
    block: 'search2',
    elem: 'button',
    content: function content(_ref) {
        var children = _ref.children,
            props = _objectWithoutProperties(_ref, ['children']);

        return props.button || _react2.default.createElement(
            _bButton2MThemeWebsearch2.default,
            props,
            children
        );
    }
}, {
    isButton: function isButton(child) {
        return child && typeof child.type === 'function' && child.type.displayName === 'search2__button';
    }
});